<template>
  <div class="header">
    <div class="header_left" @click="handleTo('/')">
      <Image class="logo" :src="logo" />
    </div>
    <el-menu class="el_menu" ref="menuRef" :default-active="defaultActive" mode="horizontal" :popper-offset="16"
      ellipsis background-color="transparent" popper-class="popper_menu" text-color="#fff" active-text-color="#19fc8f"
      @select="handleMenuSelect">
      <template v-for="item, index in getRoute">
        <template v-if="item?.children">
          <el-sub-menu :index="item?.id" :key="item?.id + '_' + index">
            <template #title>
              <trans :_t="item?.title" />
            </template>
            <el-menu-item class="menu_item" :index="val?.url" v-for="val, num in (item?.children || [])"
              :key="val.id + '_' + num">
              <template v-if="val.img">
                <div class="menu_img">
                  <Image class="aspect-ratio" style="width: 24px;margin-right: 6px;" :src="val.img" />
                </div>
              </template>
              <trans :_t="val.title" />
            </el-menu-item>
          </el-sub-menu>
        </template>
        <template v-else>
          <el-menu-item class="menu_item" :index="item?.url" :key="index">
            <trans :_t="item?.title" />
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <div class="header_right">
      <template v-if="!userInfo.token">
        <el-button class="btn" @click="handleTo('/login')">
          <trans _t="登入" />
        </el-button>
        <el-button class="btn sign_btn" @click="handleTo('/signup')">
          <trans _t="注册" />
        </el-button>
      </template>
      <template v-else>
        <el-dropdown>
          <div class="dropdown">
            {{ userInfo?.userphone }}
            <el-icon class="el-icon--right">
              <ArrowDown />
            </el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="drop_menu">
              <el-dropdown-item v-for="item, index in list" :key="index" @click="handleTo(item.url)">
                <trans :_t="item.title" />
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
      <Lan />
    </div>
  </div>
</template>
<script setup>
import logo from '@/assets/logo.png';
import getRoute from '@/utils/router';
import { nextTick, computed, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router"
import Lan from "@/components/lang.vue"
import { useUserStore, useSystemStore } from '@/store';
import { useRef, useState } from '@/hooks';

const userStore = useUserStore();
const systemStore = useSystemStore();
const router = useRouter();
const route = useRoute();
const [defaultActive, setDefaultActive] = useState('');
const userInfo = computed(() => userStore.userInfo);
const menuRef = useRef()

const list = [{
  title: '账号设定',
  url: '/user'
},
//  {
//   title: '身份认证',
//   url: '/assets/certification'
// }, 
// {
//   title: '用户回馈',
//   url: ''
// }, 
{
  title: '白皮书',
  url: '/user/about/gc'
},{
  title: '通知',
  url: '/user/message'
}, {
  title: '登出',
  url: 'logout'
}]

watch(route, (to) => {
  const activeIndex = to.path;
  setDefaultActive(activeIndex);
}, { immediate: true });

const handleMenuSelect = (url) => {
  if (url == 'service') {
    // systemStore.getSystemConfig({ kefu: true });
    if(window.ssq){
      window.ssq.push('chatOpen')
    }
    nextTick(() => {
      setDefaultActive(defaultActive.value);
    })
    return;
  }
  setDefaultActive(url);
  handleTo(url);
}


const handleTo = (url) => {
  if (!url) return;
  if (url == 'logout') return userStore.logout();
  router.push(url);
  if (url == '/') {
    nextTick(() => {
      defaultActive.value = ''
    })
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 60px;
  background: $header_bg;
  padding: 0 20px;
  font-size: 14px;
  display: flex;
  gap: 20px;
  align-items: center;

  &_left {
    display: flex;
    align-items: center;
    cursor: pointer;

    .logo {
      width: 50px;
      height: 50px;
      display: block;
    }
  }

  .el_menu {
    flex: 1;
  }

  &_right {
    color: $white;
    display: flex;
    align-items: center;

    .btn {
      min-width: 100px;
      border-radius: 8px;
      background-color: $login_btn;
      color: $white;
      font-size: 14px;
      border: none;
    }

    .sign_btn {
      background-color: $theme;
      color: $black;
    }
  }

  .dropdown {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: $white;
    cursor: pointer;

    &:focus-visible {
      outline: none;
    }

    .el-icon--right {
      font-size: 14px;
      color: $white !important;
    }

  }
}
</style>
